import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import HomeLarge from '../components/HomeLarge';
import HomeMini from '../components/HomeMini';
import BannerMainBox from '../components/BannerMainBox';
import GroupVRNSelect from '../containers/comps/GroupVRNSelectContainer'
import CusCard from '../containers/CusCardContainer'
import axiosConfig from '../config/axiosConfig';
import Swal from 'sweetalert2'
import '../css/CustomCard.css'; // Tell webpack that Button.js uses these styles
import BasicTable from '../components/Tables/AdvanceTableWithOutExport';
import { Link } from 'react-router-dom';



const firstDate = new Date();
const currentDate = new Date();
const currentHours = currentDate.getHours();

if (currentHours < 5) { // AM hours
  currentDate.setDate(currentDate.getDate() + 1); // Add one day
}
const tomorrowDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);

class ViewSuspTansHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reportData: [],
            Emailcolumns: [
              { "HeaderText": "Vehicle Number", "MappingColomn": "vrn" },
              { "HeaderText": "Driver Name", "MappingColomn": "driverName" },
              { "HeaderText": "Shell Card", "MappingColomn": "pan" },
              { "HeaderText": "Transaction Date", "MappingColomn": "transactionDate" },
              { "HeaderText": "Distance Variation in KMs", "MappingColomn": "variationinKm" },
              
          
            ],
            reportData1: [],
            Emailcolumns1: [
              { "HeaderText": "Vehicle Number", "MappingColomn": "vrn" },
              { "HeaderText": "Driver Name", "MappingColomn": "driverName" },
              { "HeaderText": "Shell Card", "MappingColomn": "pan" },
              { "HeaderText": "Count of Off-Route Transactions", "MappingColomn": "offRouteTransCount" },

            ],
            
            reportData2: [],
            Emailcolumns2: [
              { "HeaderText": "Vehicle Number", "MappingColomn": "vrn" },
              { "HeaderText": "Driver Name", "MappingColomn": "driverName" },
              { "HeaderText": "Shell Card", "MappingColomn": "pan" },
              { "HeaderText": "Count of Excessive Fueling Transactions", "MappingColomn": "excessiveFuelingTransCount" },

            ],
            
            firstDay: new Date(firstDate.getFullYear(), firstDate.getMonth(), 1),
            fromDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().substring(0, 10), //new Date(date.getFullYear(), date.getMonth(), 1);
            toDate: new Date().toISOString().substring(0, 10),
            // toDate: tomorrowDate.toISOString().substring(0, 10),
            Option: 1,
            Group: 0,
            Vehicle: 0,
            testvariable: false,
            "OVER_SPEEDING": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "HARSH_BRAKING": {
                currentMonthReading: 59,
                previosMonthReading: 60,
                percentDifferent: 1
            },
            "HARSH_TURN": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "SEAT_BELT_VIOLATION": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "IDLING_TIME": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "HARSH_ACCELERATION": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "HSSE_SCORE": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 0
            },
            fodata: {},
            suspiciousdata: {},
        };
        this.optionChange = this.optionChange.bind(this)
        this.groupChange = this.groupChange.bind(this)
        this.fromDateChange = this.fromDateChange.bind(this)
        this.toDateChange = this.toDateChange.bind(this)
        this.vehicleChange = this.vehicleChange.bind(this)
        this.getAnalyticsData = this.getAnalyticsData.bind(this)
        this.getSuspiciousData = this.getSuspiciousData.bind(this)


    }

    async getHSSEData() {
        await axiosConfig.post('Portal/GetFuelingSafetyEventData', {
            "UserAccountBranchID": this.props.data.selectedBranchId,
            "SearchTypeId": this.state.Option,
            "CardMappingMasterId": this.state.Vehicle,
            "VRNGroupMasterId": this.state.Group,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
        })
            .then((res) => {
                for (var i = 0; i < res.data.eventAnalytics.length; i++) {
                    this.setState((prevState) => ({
                        [res.data.eventAnalytics[i].event]: {
                            currentMonthReading: res.data.eventAnalytics[i].currentMonthReading,
                            percentDifferent: res.data.eventAnalytics[i].percentDifferent,
                            previosMonthReading: res.data.eventAnalytics[i].previosMonthReading,
                        }
                    }));
                }
            })
            .catch(console.error)
            .finally(() => {
            });
    }

    async getFOData() {

        await axiosConfig.post('Portal/GetFleetOverView', {
            "UserAccountBranchID": this.props.data.selectedBranchId,
            "SearchTypeId": this.state.Option,
            "CardMappingMasterId": this.state.Vehicle,
            "VRNGroupMasterId": this.state.Group,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
        })
            .then((res) => {
                this.setState({ fodata: res.data.fleetOverView[0] })
                console.log("fo", res.data.fleetOverView[0]);
            })
            .catch(console.error)
            .finally(() => {
            });


    }

    getSuspiciousData() {
        axiosConfig.post('Portal/GetDashBoardSuspiciousTransAnalytics', {
            "UserAccountBranchID": this.props.data.selectedBranchId,
            "SearchTypeId": this.state.Option,
            "CardMappingMasterId": this.state.Vehicle,
            "VRNGroupMasterId": this.state.Group,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
        })
            .then((res) => {

                this.setState({ suspiciousdata: res.data.suspiciousTranAnalytics[0] })

            })
            .catch(console.error)
            .finally(() => {
                Swal.close();

            });

    }

    getAnalyticsData() {


        Swal.fire({
            title: 'Please Wait ...',
            onBeforeOpen() {
                Swal.showLoading()
            },
            onAfterClose() {
                Swal.hideLoading()
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCancelButton: false,
            showConfirmButton: false
        })

        this.getHSSEData()
        this.getFOData()
        this.getSuspiciousData()
        debugger
        let token = localStorage.getItem("token");
        var FromDateArr = this.state.fromDate.split("T");
        var ToDateArr = this.state.toDate.split("T");
        
        


        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig
          .post("Portal/HighestDistanceVariationReport", {
            "UserAccountBranchID": this.props.data.selectedBranchId,
            "SearchTypeId": this.state.Option,
            "CardMappingMasterId": this.state.Vehicle,
            "VRNGroupMasterId": this.state.Group,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
          })
          .then((Response) => {
             //debugger
            this.setState({ reportData: Response.data.data });
            Swal.close();
          })
          .catch((error) => {
            Swal.close();
            Swal.fire({
              title: error.response.data.errorMessage,
              icon: "error",
              confirmButtonText: "Okay",
            });
          });

        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig
          .post("Portal/MostOffRouteTransactionsReport", {
            "UserAccountBranchID": this.props.data.selectedBranchId,
            "SearchTypeId": this.state.Option,
            "CardMappingMasterId": this.state.Vehicle,
            "VRNGroupMasterId": this.state.Group,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
          })
          .then((Response) => {
             //debugger
            this.setState({ reportData1: Response.data.data });
            Swal.close();
          })
          .catch((error) => {
            Swal.close();
            Swal.fire({
              title: error.response.data.errorMessage,
              icon: "error",
              confirmButtonText: "Okay",
            });
          });

          axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig
          .post("Portal/HighestExcessiveDailyFuelingReport", {
            "UserAccountBranchID": this.props.data.selectedBranchId,
            "SearchTypeId": this.state.Option,
            "CardMappingMasterId": this.state.Vehicle,
            "VRNGroupMasterId": this.state.Group,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
          })
          .then((Response) => {
            debugger
            this.setState({ reportData2: Response.data.data });
            Swal.close();
          })
          .catch((error) => {
            
            Swal.close();
            Swal.fire({
              title: error.response.data.errorMessage,
              icon: "error",
              confirmButtonText: "Okay",
            });
          });

    }

    testFunction() {
        console.log('test function executed');
    }

    componentDidMount() {

        // console.log(this.state.testvariable);

        // let width = window.innerWidth/1.2;
        // let height = window.innerHeight/1.2;

        // Swal.fire({
        //     showCloseButton: true,
        //     showConfirmButton: false,
        //     width: width,
        //     imageUrl: '/telematicsportal/imageassets/splpopup.jpg',
        //     imageWidth: width,
        //     imageHeight: height,
        //     onClose: this.getAnalyticsData

        //     }).then(function () {

        //     });


        this.getAnalyticsData();

        debugger
        let token = localStorage.getItem("token");
        var FromDateArr = this.state.fromDate.split("T");
        var ToDateArr = this.state.toDate.split("T");
        
        


        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig
          .post("Portal/HighestDistanceVariationReport", {
            "UserAccountBranchID": this.props.data.selectedBranchId,
            "SearchTypeId": this.state.Option,
            "CardMappingMasterId": this.state.Vehicle,
            "VRNGroupMasterId": this.state.Group,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
          })
          .then((Response) => {
             //debugger
            this.setState({ reportData: Response.data.data });
            Swal.close();
          })
          .catch((error) => {
            Swal.close();
            Swal.fire({
              title: error.response.data.errorMessage,
              icon: "error",
              confirmButtonText: "Okay",
            });
          });

        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig
          .post("Portal/MostOffRouteTransactionsReport", {
            "UserAccountBranchID": this.props.data.selectedBranchId,
            "SearchTypeId": this.state.Option,
            "CardMappingMasterId": this.state.Vehicle,
            "VRNGroupMasterId": this.state.Group,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
          })
          .then((Response) => {
             //debugger
            this.setState({ reportData1: Response.data.data });
            Swal.close();
          })
          .catch((error) => {
            Swal.close();
            Swal.fire({
              title: error.response.data.errorMessage,
              icon: "error",
              confirmButtonText: "Okay",
            });
          });

          axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig
          .post("Portal/HighestExcessiveDailyFuelingReport", {
            "UserAccountBranchID": this.props.data.selectedBranchId,
            "SearchTypeId": this.state.Option,
            "CardMappingMasterId": this.state.Vehicle,
            "VRNGroupMasterId": this.state.Group,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
          })
          .then((Response) => {
            debugger
            this.setState({ reportData2: Response.data.data });
            Swal.close();
          })
          .catch((error) => {
            Swal.close();
            Swal.fire({
              title: error.response.data.errorMessage,
              icon: "error",
              confirmButtonText: "Okay",
            });
          });
       

        // Swal.fire({
        //     showCloseButton: true,
        //     width: width,
        //     imageUrl: '/telematicsportal/imageassets/splpopup.jpg',
        //     imageWidth: width,
        //     imageHeight: height,
        //     preConfirm: () => {
        //         console.log('inside preconfirm');
        //         this.getAnalyticsData()
        //       }
        //   }).then(function () {

        //     console.log('Closed');
        //   }
        //   )
    }

    async optionChange(selectedOption) {
        if (this.state.Option != selectedOption && selectedOption == 1) {
            await this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })
            this.getAnalyticsData()
        }
        else
            await this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })
    }

    async vehicleChange(selectedVehicle) {
        await this.setState({ Vehicle: selectedVehicle, Group: 0 })
        this.getAnalyticsData()
    }

    async groupChange(selectedGroup) {
        await this.setState({ Group: selectedGroup, Vehicle: 0 })
        this.getAnalyticsData()
    }

    async fromDateChange(p) {
        await this.setState({
            fromDate: p.target.value,
      
          });
          localStorage.setItem('fromDateTransReport', p.target.value);

        this.getAnalyticsData()
    }

    async toDateChange(p) {
        await this.setState({
            toDate: p.target.value,
      
          });
          localStorage.setItem('toDateTransReport', p.target.value);

        this.getAnalyticsData()
    }

    render() {
        return (
            <Container>
                <div style={{ textAlign: 'left', marginLeft: '30px' }}>
        <Link to="/ManageSusTransSub" className="btn btn-shell mr-1 mb-1">Back</Link>
      </div>
                {/* <BannerMainBox selectedBranch={this.props.data.selectedBranchNumber} /> */}
                <Row className="col-md-12">
                    <GroupVRNSelect
                        showFilterText='true'
                        showVehiclesInDropDown='yes'
                        isMultiInGroup='false'
                        isMultiInVehicle='false'
                        onOptionChange={this.optionChange}
                        onGroupChange={this.groupChange}
                        onVehicleChange={this.vehicleChange}
                    ></GroupVRNSelect>
                </Row>
                <Row className="pt-4 pl-0 col-md-12">
                    {/* <div className="col-md-6 col-12">
                        <div className="form-label-group">
                            <input type="date" name="startDate" className="form-control" onChange={this.fromDateChange} value={this.state.fromDate}  />
                            <label htmlFor="country-floating">Date From</label>
                        </div>
                    </div> */}
                    <div className="col-md-6 col-12">
    <div className="form-label-group">
        <input
            type="date"
            name="startDate"
            className="form-control"
            onChange={this.fromDateChange}
            value={this.state.fromDate}
            onKeyDown={(e) => e.preventDefault()} // Prevent typing using the keyboard
            max={ new Date(currentDate.getTime()).toISOString().substring(0, 10)}
        />
        <label htmlFor="country-floating">From Date</label>
    </div>
</div>
                    <div className="col-md-6 col-12">
                        <div className="form-label-group">
                            <input type="date" name="endDate" className="form-control" onChange={this.toDateChange} value={this.state.toDate} min={this.state.fromDate} onKeyDown={(e) => e.preventDefault()} max={ new Date(currentDate.getTime()).toISOString().substring(0, 10)}  />
                            <label htmlFor="country-floating">To Date</label>
                        </div>
                    </div>
                </Row>
                {/* <Row>
                    <Col>                    
                        <CardDeck>
                            
                            <HomeLarge Title="Fleet Overview" Icon="fa fa-truck font-medium-5" Redirect='/GeneralReports?reportType=ShellCardTransactions' />                            
                            <HomeMini status={this.state.fodata.volumeDifference} quantityPrice={this.state.fodata.volumeCurrentMonth + ' L'} Icon="fa fa-credit-card font-medium-5" percentage={this.state.fodata.volumePercentage} description="Shell Card Volume (L)" cssName="avatar p-50 m-0 mb-1 avatar-blue" />
                            <HomeMini status={this.state.fodata.amountDifference} quantityPrice={'PKR ' + this.state.fodata.amountCurrentMonth} Icon="fa fa-money text-warning font-medium-5" percentage={this.state.fodata.amountPercentage} description="Shell Card Spend (PKR)" cssName="avatar bg-rgba-warning p-50 m-0 mb-1" />
                            <HomeMini status={this.state.fodata.travelDistanceDifference} quantityPrice={this.state.fodata.totalTravelsDistanceCurrentMonth + ' KM'} Icon="fa fa-road text-primary font-medium-5" percentage={this.state.fodata.travelDistancePercentage} description="Distance Travelled" cssName="avatar bg-rgba-danger p-50 m-0 mb-1" />
                            <HomeMini status={this.state.fodata.travelTimeDifference} quantityPrice={this.state.fodata.totalTravelsTimeCurrentMonth + ' Hours'} Icon="fa fa-tint text-primary font-medium-5" percentage={this.state.fodata.travelTimePercentage} description="Total Driven Hours" cssName="avatar bg-rgba-primary p-50 m-0 mb-1" />
                            <HomeMini status={this.state.fodata.avgMileageDifference} quantityPrice={this.state.fodata.avgMileagePerKMCurrentMonth + ' KM/L'} Icon="fa fa-database text-success font-medium-5" percentage={this.state.fodata.avgMileagePercentage} description="Average Vehicle Shell Card Mileage (KM/L)" cssName="avatar bg-rgba-success p-50 m-0 mb-1" />
                        </CardDeck>
                    </Col>
                </Row> */}

                <Row>
                    <Col>
                        <CardDeck>
                            <HomeLarge Title="Suspicious Transactions Overview" Icon="fa fa-credit-card font-medium-5" Redirect='/SuspiciousReports?reportType=SuspiciousTransactionsSummary' />
                            <HomeMini status={this.state.suspiciousdata.suspiciousDifference} quantityPrice={this.state.suspiciousdata.totalSuspiciousTransactions } Icon="fa fa-exclamation-triangle text-info font-medium-5" percentage={this.state.suspiciousdata.suspiciousPercentage} description="Total Transactions conducted on Shell Card" cssName="avatar bg-rgba-info p-50 m-0 mb-1" />
                            {/* <HomeMini status={this.state.suspiciousdata.lowVehicleMileageDifference} quantityPrice={this.state.suspiciousdata.lowVehicleMileage + ' PKR'} Icon="fa fa-map text-warning font-medium-5" percentage={this.state.suspiciousdata.lowVehicleMileagePercentage} description="Low Mileage Transactions" cssName="avatar bg-rgba-warning p-50 m-0 mb-1" /> */}
                            <HomeMini status={this.state.suspiciousdata.excessiveDailyFuelingDifference} quantityPrice={this.state.suspiciousdata.excessiveDailyFuelingTransactions } Icon="fa fa-tint text-success font-medium-5" percentage={this.state.suspiciousdata.excessiveDailyFuelingPercentage} description="Excessive Daily Fueling Transactions" cssName="avatar bg-rgba-danger p-50 m-0 mb-1" />
                            <HomeMini status={this.state.suspiciousdata.locationMismatchTransactionsDifference} quantityPrice={this.state.suspiciousdata.locationMismatchTransactions } Icon="fa fa-map text-primary font-medium-5" percentage={this.state.suspiciousdata.locationMismatchTransactionsPercentage} description="Location Mismatch Transactions" cssName="avatar bg-rgba-primary p-50 m-0 mb-1" />
                            <HomeMini status={this.state.suspiciousdata.deviatedRouteTransactionsDifference} quantityPrice={this.state.suspiciousdata.deviatedRouteTransactions} Icon="fa fa-database text-danger font-medium-5"  percentage={this.state.suspiciousdata.deviatedRouteTransactionsPercentage} description="Off-Route Transactions" cssName="avatar bg-rgba-success p-50 m-0 mb-1" />
                        </CardDeck>
                    </Col>
                </Row>

                {/* <Row>
                    <Col>
                        <CardDeck>
                            <HomeLarge Title="Safety" Icon="fa fa-exclamation-triangle font-medium-5" Redirect='/GeneralReports?reportType=SafetyViolation' />
                            <HomeMini status={this.state.HSSE_SCORE.percentDifferent} quantityPrice={this.state.HSSE_SCORE.currentMonthReading} Icon="fa fa-truck text-warning font-medium-5" percentage={this.state.HSSE_SCORE.previosMonthReading} description="Safety Score" cssName="avatar bg-rgba-warning p-50 m-0 mb-1" />
                            <HomeMini status={this.state.HARSH_BRAKING.percentDifferent} quantityPrice={this.state.HARSH_BRAKING.currentMonthReading} Icon="fa fa-empire text-success font-medium-5" percentage={this.state.HARSH_BRAKING.previosMonthReading} description="Incidents of Harsh Braking" cssName="avatar bg-rgba-success p-50 m-0 mb-1" />
                            <HomeMini status={this.state.HARSH_ACCELERATION.percentDifferent} quantityPrice={this.state.HARSH_ACCELERATION.currentMonthReading} Icon="fa fa-road text-primary font-medium-5" percentage={this.state.HARSH_ACCELERATION.previosMonthReading} description="Incidents of Harsh Acceleration" cssName="avatar bg-rgba-primary p-50 m-0 mb-1" />
                            <HomeMini status={this.state.HARSH_TURN.percentDifferent} quantityPrice={this.state.HARSH_TURN.currentMonthReading} Icon="fa fa-eercast text-info font-medium-5" percentage={this.state.HARSH_TURN.previosMonthReading} description="Incidents of Harsh Turn" cssName="avatar bg-rgba-info p-50 m-0 mb-1" />
                            <HomeMini status={this.state.OVER_SPEEDING.percentDifferent} quantityPrice={this.state.OVER_SPEEDING.currentMonthReading} Icon="fa fa-car text-danger font-medium-5" percentage={this.state.OVER_SPEEDING.previosMonthReading} description="Incidents of Overspeeding" cssName="avatar bg-rgba-danger p-50 m-0 mb-1" />
                        </CardDeck>
                    </Col>
                </Row> */}


                {/* <Row>
                    <Col xs={2} >
                        <div style={{ height: "210px" }} >
                            <Card className="text-center bg-shell h-100">
                                <div className="card-content mt-6" style={{ margin: 'auto' }}>
                                    <Card.Header className="text-center">
                                    </Card.Header>

                                    <Card.Body>
                                        <div className="avatar avatar_shell bg-rgba-shell p-50 m-0 mb-1">
                                            <i className="fa fa-exclamation-triangle font-medium-5" />
                                        </div>
                                        <h2 className="text-bold-700" style={{ color: '#595959', margin: 'auto', fontSize: '18px' }}>Safety</h2>
                                    </Card.Body>
                                </div>
                            </Card>
                        </div>
                    </Col>
                    <Col>
                        <CardDeck>
                            <HomeMini status={this.state.HSSE_SCORE.percentDifferent} quantityPrice={this.state.HSSE_SCORE.currentMonthReading} Icon="fa fa-truck text-warning font-medium-5" percentage={this.state.HSSE_SCORE.previosMonthReading} description="Safety Score" cssName="avatar bg-rgba-warning p-50 m-0 mb-1" />
                            <HomeMini status={this.state.HARSH_BRAKING.percentDifferent} quantityPrice={this.state.HARSH_BRAKING.currentMonthReading} Icon="fa fa-empire text-success font-medium-5" percentage={this.state.HARSH_BRAKING.previosMonthReading} description="Incidents of Harsh Braking" cssName="avatar bg-rgba-success p-50 m-0 mb-1" />
                            <HomeMini status={this.state.HARSH_ACCELERATION.percentDifferent} quantityPrice={this.state.HARSH_ACCELERATION.currentMonthReading} Icon="fa fa-road text-primary font-medium-5" percentage={this.state.HARSH_ACCELERATION.previosMonthReading} description="Incidents of Harsh Acceleration" cssName="avatar bg-rgba-primary p-50 m-0 mb-1" />
                            <HomeMini status={this.state.HARSH_TURN.percentDifferent} quantityPrice={this.state.HARSH_TURN.currentMonthReading} Icon="fa fa-eercast text-info font-medium-5" percentage={this.state.HARSH_TURN.previosMonthReading} description="Incidents of Harsh Turn" cssName="avatar bg-rgba-info p-50 m-0 mb-1" />
                            <HomeMini status={this.state.OVER_SPEEDING.percentDifferent} quantityPrice={this.state.OVER_SPEEDING.currentMonthReading} Icon="fa fa-car text-danger font-medium-5" percentage={this.state.OVER_SPEEDING.previosMonthReading} description="Incidents of Overspeeding" cssName="avatar bg-rgba-danger p-50 m-0 mb-1" />
                        </CardDeck>
                        <CardDeck>

                            <HomeMini status={this.state.SEAT_BELT_VIOLATION.percentDifferent} quantityPrice={this.state.SEAT_BELT_VIOLATION.currentMonthReading} Icon="fa fa-openid text-primary font-medium-5" percentage={this.state.SEAT_BELT_VIOLATION.previosMonthReading} description="Incidents of Seatbelt Violations" cssName="avatar bg-rgba-primary p-50 m-0 mb-1" />
                            <HomeMini quantityPrice="0" Icon="fa fa-bitbucket text-danger font-medium-5" percentage="0" description="Incidents of Battery Tamper" cssName="avatar bg-rgba-danger p-50 m-0 mb-1" />
                            <HomeMini quantityPrice="0" Icon="fa fa-eercast text-success font-medium-5" percentage="0" description="Incidents of Contiuous Driving > 3 Hours" cssName="avatar bg-rgba-success p-50 m-0 mb-1" />
                            <HomeMini quantityPrice="0" Icon="fa fa-tint text-warning font-medium-5" percentage="0" description="Incidents of Rest Hours <15 Mins" cssName="avatar bg-rgba-warning p-50 m-0 mb-1" />
                            <HomeMini status={this.state.IDLING_TIME.percentDifferent} quantityPrice={this.state.IDLING_TIME.currentMonthReading} Icon="fa fa-road text-info font-medium-5" percentage={this.state.IDLING_TIME.previosMonthReading} description="Idling Hours" cssName="avatar bg-rgba-info p-50 m-0 mb-1" />
                        </CardDeck>

                    </Col>
                </Row> */}
     
<div className="row">
                <div className="col-md-12 col-12">
                  <div className="col-md-12 col-12">
                  {/* <Row className="col-md-12 justify-content-center bg-white text-dark rounded-pill link p-2">
            <p style={{fontWeight: "bold",fontFamily: "Arial, sans-serif",fontSize: "24px"}}>Highest Distance Variation</p>
          </Row> */}
          <Row className="col-md-12 justify-content-center bg-white text-dark rounded-pill">
      
      <p style={{ fontWeight: "bold",fontFamily: "Arial, sans-serif",fontSize: "24px", paddingTop:"11px" }}>Highest Distance Variation</p>
  
      </Row>
                    <BasicTable
                      data={this.state.reportData}
                      columns={this.state.Emailcolumns}
                    />
                  </div>
                </div>
              </div>
          
              <div className="row">
                <div className="col-md-12 col-12">
                  <div className="col-md-12 col-12">
                  {/* <Row className="col-md-12 justify-content-center bg-white text-dark rounded-pill link p-2">
            <p style={{fontWeight: "bold",fontFamily: "Arial, sans-serif",fontSize: "24px"}}>Most Off-Route Transactions</p>
          </Row> */}
              <Row className="col-md-12 justify-content-center bg-white text-dark rounded-pill ">
      
      <p style={{ fontWeight: "bold",fontFamily: "Arial, sans-serif",fontSize: "24px", paddingTop:"11px" }}>Most Off-Route Transactions</p>
  
      </Row>
                    <BasicTable
                      data={this.state.reportData1}
                      columns={this.state.Emailcolumns1}
                    />
                  </div>
                </div>
              </div>
       
              <div className="row">
                <div className="col-md-12 col-12">
                  <div className="col-md-12 col-12">
                  {/* <Row className="col-md-12 justify-content-center bg-white text-dark rounded-pill link p-2">
            <p style={{fontWeight: "bold",fontFamily: "Arial, sans-serif",fontSize: "24px"}}>Highest Excessive Daily Fuelling</p>
          </Row> */}
                 <Row className="col-md-12 justify-content-center bg-white text-dark rounded-pill">
      
      <p style={{ fontWeight: "bold",fontFamily: "Arial, sans-serif",fontSize: "24px", paddingTop:"11px" }}>Highest Excessive Daily Fueling</p>
  
      </Row>
                    <BasicTable
                      data={this.state.reportData2}
                      columns={this.state.Emailcolumns2}
                    />
                  </div>
                </div>
              </div>

            </Container>
        );
    }
}

export default ViewSuspTansHome;